import { useRef } from 'react';
import { useSidePanelStore } from '../store';
import { getConfigObject } from '../../../utils/config';

function useSidePanel() {
  const [state, dispatch] = useSidePanelStore();
  const sidePanelRef = useRef(null);
  const url = getConfigObject().PANELS_SERVICE_URL;

  return {
    url,
    sidePanelRef,
    state,
    dispatch,
  };
}

export default useSidePanel;
